import React from 'react';
import FilterVisaOnArrival from './filter-visa-on-arrival';
import Stops from './stops';
import Price from './price';
import Duration from './duration';
import FamousFor from './famous-for';
import * as S from './filters.styles';

const FiltersUI = ({
  filterSettings,
  updateFilter,
  isRoundTrip,
  isFilterApplied,
  onwardMaxPrice,
  onwardMinPrice,
  onwardDuration,
  handleResetIndividualFilter,
  isLoading,
  famousFor,
  showCountries = [],
  handleResetFilters
}) => {
  const famousForArray = famousFor && Array.from(famousFor);

  return (
    <>
      <S.FltHpyFilter>
        <S.StickyHpy>
          <div className="flexCol">
            <S.PolicyTag
              className="marginB10"
              onClick={() => {
                window.open(
                  'https://www.goibibo.com/info/international-travel-guidelines',
                  '_blank'
                );
              }}
            >
              <p className="marginB10">
                <span className="tag">COVID</span>
              </p>
              <p className="f500">Travel policies for Indian tourists</p>
            </S.PolicyTag>
            <S.FilterWrap>
              <S.FilterTypeWrap>
                <div className="dF justifyBetween">
                  <div>
                    <S.Hd16 className="greyCnt f500 marginB10">FILTERS</S.Hd16>
                  </div>
                  <S.Reset clickable={isFilterApplied} onClick={handleResetFilters}>
                    RESET ALL
                  </S.Reset>
                </div>
              </S.FilterTypeWrap>
              {showCountries.length > 0 ? (
                <S.FilterTypeWrap>
                  <FilterVisaOnArrival
                    filterType="showCountries"
                    updateFilter={updateFilter}
                    showCountriesFilter={filterSettings.showCountries.values}
                    showCountries={showCountries}
                  />{' '}
                  <div className="brdrBot padB10"></div>
                </S.FilterTypeWrap>
              ) : null}

              {!isRoundTrip ? (
                <S.FilterTypeWrap>
                  <Stops
                    title={isRoundTrip ? 'Onward Stops' : 'Stops'}
                    filterType="onwardStops"
                    stopsFilters={filterSettings.onwardStops.values}
                    updateFilter={updateFilter}
                  />
                  <div className="brdrBot padT10 padB20"></div>
                </S.FilterTypeWrap>
              ) : null}

              <S.FilterTypeWrap>
                <Price
                  title="Price Range"
                  filterType="price"
                  priceFilters={filterSettings.price.values}
                  updateFilter={updateFilter}
                  minPrice={onwardMinPrice}
                  maxPrice={onwardMaxPrice}
                  handleResetIndividualFilter={handleResetIndividualFilter}
                  isLoading={isLoading}
                  tripType={isRoundTrip ? 'rt' : 'ow'}
                />
                <div className="brdrBot padT10 padB20"></div>
              </S.FilterTypeWrap>

              <S.FilterTypeWrap>
                <Duration
                  title="Flight Duration"
                  filterType="duration"
                  durationFilters={filterSettings.duration.values}
                  updateFilter={updateFilter}
                  minDuration={onwardDuration && onwardDuration.min}
                  maxDuration={onwardDuration && onwardDuration.max}
                  handleResetIndividualFilter={handleResetIndividualFilter}
                  isLoading={isLoading}
                />
                <div className="brdrBot padT10 padB20"></div>
              </S.FilterTypeWrap>

              {famousForArray && famousForArray.length > 0 ? (
                <S.FilterTypeWrap>
                  <FamousFor
                    updateFilter={updateFilter}
                    famousFor={famousForArray}
                    handleResetIndividualFilter={handleResetIndividualFilter}
                    famousForFilters={filterSettings.famousFor.values}
                  />
                </S.FilterTypeWrap>
              ) : null}
            </S.FilterWrap>
          </div>
        </S.StickyHpy>
      </S.FltHpyFilter>
    </>
  );
};
export default FiltersUI;
